<template>
  <div>
    <!-- 移动端导航 - 仅在未登录时显示 -->
    <nav v-if="!isLoggedIn" class="iAIOVd visible-xs-block navbar navbar-default">
      <div class="container">
        <div data-radium="true">
          <!-- 遮罩层 -->
          <div
            class="bm-overlay"
            data-radium="true"
            :style="{
              position: 'fixed',
              zIndex: 1,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.3)',
              opacity: isMobileMenuOpen ? 1 : 0,
              transition: 'opacity 0.3s, transform 0.3s',
              transform: isMobileMenuOpen ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0px, 0px)'
            }"
            @click="closeMobileMenu"
          ></div>
          <!-- 侧边菜单 -->
          <div
            class="bm-menu-wrap"
            data-radium="true"
            :style="{
              position: 'fixed',
              right: 'inherit',
              zIndex: 2,
              width: '300px',
              height: '100%',
              transition: '0.5s',
              transform: isMobileMenuOpen ? 'translate3d(0, 0, 0)' : 'translate3d(-100%, 0px, 0px)'
            }"
          >
            <div class="bm-menu" data-radium="true" style="height: 100%; box-sizing: border-box; overflow: auto;">
              <nav class="bm-item-list" data-radium="true" style="height: 100%;">
                <router-link to="/" data-radium="true" style="display: block; outline: none;" @click.native="closeMobileMenu">
                  <span>Home</span>
                </router-link>
                <!-- <a href="#/contact" data-radium="true" style="display: block; outline: none;">
                  <span>联系</span>
                </a> -->
                <router-link to="/contact" data-radium="true" style="display: block; outline: none;" @click.native="closeMobileMenu">
                  <span>Contact</span>
                </router-link>
                <!-- <router-link to="/categories" data-radium="true" style="display: block; outline: none;">
                  <span>分类</span>
                </router-link> -->
                <a href="#/about" data-radium="true" style="display: block; outline: none;" @click="closeMobileMenu">
                  <span>About</span>
                </a>
                <router-link to="/faq" data-radium="true" style="display: block; outline: none;" @click.native="closeMobileMenu">
                  <span>FAQ</span>
                </router-link>
                <a
                  data-radium="true"
                  style="display: block; outline: none; cursor: pointer;"
                  @click="showSignupModal"
                >
                  <span>Sign Up</span>
                </a>
                <a
                  data-radium="true"
                  style="display: block; outline: none; cursor: pointer;"
                  @click="showLoginModal"
                >
                  <span>Log In</span>
                </a>
              </nav>
            </div>
            <div data-radium="true">
              <!-- 关闭按钮 -->
              <div
                class="bm-cross-button"
                data-radium="true"
                style="position: absolute; width: 24px; height: 24px; right: 8px; top: 8px; cursor: pointer;"
                @click="closeMobileMenu"
              >
                <span data-radium="true" style="position: absolute; top: 6px; right: 14px;">
                  <span
                    class="bm-cross"
                    data-radium="true"
                    style="position: absolute; width: 3px; height: 14px; transform: rotate(45deg); background: #bdc3c7;"
                  ></span>
                  <span
                    class="bm-cross"
                    data-radium="true"
                    style="position: absolute; width: 3px; height: 14px; transform: rotate(-45deg); background: #bdc3c7;"
                  ></span>
                </span>
                <button
                  data-radium="true"
                  style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; margin: 0px; padding: 0px; border: none; text-indent: -9999px; background: transparent; outline: none; cursor: pointer;"
                >
                  Close Menu
                </button>
              </div>
            </div>
          </div>
          <!-- 汉堡图标 -->
          <div class="bm-burger-button" data-radium="true" style="z-index: 1; cursor: pointer;" @click="toggleMobileMenu">
            <span data-radium="true">
              <span
                class="bm-burger-bars"
                data-radium="true"
                :style="{
                  position: 'absolute',
                  height: '20%',
                  left: '0px',
                  right: '0px',
                  top: '0%',
                  opacity: isMobileMenuOpen ? 0.6 : 1,
                  background: '#373a47'
                }"
              ></span>
              <span
                class="bm-burger-bars"
                data-radium="true"
                :style="{
                  position: 'absolute',
                  height: '20%',
                  left: '0px',
                  right: '0px',
                  top: '40%',
                  opacity: isMobileMenuOpen ? 0.6 : 1,
                  background: '#373a47'
                }"
              ></span>
              <span
                class="bm-burger-bars"
                data-radium="true"
                :style="{
                  position: 'absolute',
                  height: '20%',
                  left: '0px',
                  right: '0px',
                  top: '80%',
                  opacity: isMobileMenuOpen ? 0.6 : 1,
                  background: '#373a47'
                }"
              ></span>
            </span>
            <button
              data-radium="true"
              style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; margin: 0px; padding: 0px; border: none; opacity: 0; font-size: 8px; cursor: pointer;"
            >
              Open Menu
            </button>
          </div>
        </div>
        <a class="logo center-brand-img center-brand navbar-brand" href="#/">
          <img
            class="kZOCSA"
            alt="logo"
            src="@/assets/logo.jpg"
          >
        </a>
      </div>
    </nav>

    <!-- 桌面端导航 - 未登录 -->
    <nav v-if="!isLoggedIn" class="fMigQv animated fadeIn hidden-xs">
      <div class="bPxaRs hvoxeo">
        <div class="imajGg">
          <router-link to="/" class="jFIvso">
            <img
              class="kZOCSA"
              alt="logo"
              src="@/assets/logo.jpg"
            >
          </router-link>
          <div class="eLGvhP">
            <router-link class="eXNqpM" to="/">
              <div class="fAWYHm">
                <span>Shop</span>
                <div class="fIJWXo"></div>
              </div>
            </router-link>
            <a class="eXNqpM" style="margin-left: 30px;" href="https://maijia.koiodeal.com/#/" target="_blank">
              <div class="fAWYHm">
                <span>Seller Sign Up</span>
              </div>
            </a>
          </div>
        </div>
        <div class="htRjuh">
          <div
            style="align-items: center; color: rgb(0, 0, 0); cursor: pointer; display: flex; font-size: 18px; font-weight: 500; padding-right: 40px;"
            @click="showSignupModal"
          >
            <span>Sign Up</span>
          </div>
          <div
            style="align-items: center; color: rgb(0, 0, 0); cursor: pointer; display: flex; font-size: 18px; font-weight: 500;"
            @click="showLoginModal"
          >
            <span>Log In</span>
          </div>
        </div>
      </div>
    </nav>

    <!-- 桌面端导航 - 已登录 -->
    <nav v-else class="sc-jItqcz fGDFIV animated fadeIn d-none d-sm-block">
      <div class="sc-kgKVFY sc-cjERFW bFLUky bABEsA">
        <div class="sc-hhGHuG ioMmig">
          <router-link to="/" class="sc-cCYyox jwXipJ">
            <img
              alt="logo"
              src="@/assets/logo.jpg"
              class="sc-gXSCqU iSKCmg"
              style="width: 47px;"
            >
          </router-link>
          <div class="sc-gjTGSA jzQpMF">
            <router-link class="sc-bZPPFW jRZLKX" to="/">
              <div class="sc-kMrHXl giQiXZ" :class="{ active: isActive('/') }">
                Shop
                <!-- active indicator -->
                <div class="sc-ilEZps bDWafU" v-if="isActive('/')"></div>
              </div>
            </router-link>
            <router-link class="sc-bZPPFW jRZLKX" to="/snags">
              <div class="sc-kMrHXl giQiXZ" :class="{ active: isActive('/snags') }">
                Orders
                <!-- active indicator -->
                <div class="sc-ilEZps bDWafU" v-if="isActive('/snags')"></div>
              </div>
            </router-link>
            <router-link class="sc-bZPPFW jRZLKX" to="/wallet">
              <div class="sc-kMrHXl giQiXZ" :class="{ active: isActive('/wallet') }">
                Wallet
                <!-- active indicator -->
                <div class="sc-ilEZps bDWafU" v-if="isActive('/wallet')"></div>
              </div>
            </router-link>
            <!-- 收藏页图标 -->
            <router-link class="sc-bZPPFW jRZLKX" to="/favorites">
              <div class="sc-kMrHXl giQiXZ" :class="{ active: isActive('/favorites') }">
                <!-- 未选中收藏图标 -->
                <svg
                  v-if="!isActive('/favorites')"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="18 18 60 60"
                  width="24px"
                  height="24px"
                  class="sc-iKGpAt fydLGD"
                  style="max-width: 20px;"
                >
                  <g>
                    <path
                      d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z"
                    ></path>
                  </g>
                </svg>
                <!-- 选中收藏图标 -->
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="18 18 60 60"
                  width="24px"
                  height="24px"
                  class="sc-iKGpAt fydLGD2"
                  style="max-width: 20px;"
                >
                  <g>
                    <path
                      d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z"
                    ></path>
                  </g>
                </svg>
              </div>
            </router-link>
          </div>
        </div>
        <div class="sc-jegxcv iPsaAj">
          <!-- <span style="margin-right: 20px;">
            <div style="color: rgb(170, 170, 170); cursor: default; font-size: 14px;">0 snags left</div>
          </span>
          <span id="react-notifications">
            <div class="sc-cyRfQX eTftWW" style="margin-right: 20px; cursor: pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
          </span> -->
          <div class="x-dropdown d-none d-sm-block">
            <!-- 点击头像切换下拉菜单 -->
            <div class="x-dropdown--btn" @click="toggleDropdown">
              <div
                class="sb-avatar sb-avatar--text"
                style="display: inline-block; vertical-align: middle; width: 50px; height: 50px; border-radius: 100%; font-family: Helvetica, Arial, sans-serif; cursor: pointer;"
              >
                <div
                  class="sb-avatar__text"
                  :title="userName"
                  style="width: 50px; height: 50px; line-height: initial; text-align: center; color: rgb(255, 255, 255); background: rgb(255, 0, 0); border-radius: 100%;"
                >
                  <div style="display: table; table-layout: fixed; width: 100%; height: 100%; font-size: 16.6667px;">
                    <span style="display: table-cell; vertical-align: middle; white-space: nowrap;">
                      <span>{{ userInitial }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 下拉菜单容器 -->
            <div class="x-dropdown--container" :class="{ 'x-dropdown--container__opened': isDropdownOpen }">
              <div class="sc-lnAgIa hXeGIk x-dropdown--element">
                <div><router-link to="/account">Account</router-link></div>
                <div><router-link to="/faq">FAQ</router-link></div>
                <div><router-link to="/contact">Contact</router-link></div>
                <div><a href="javascript:void(0)" @click="handleLogout">Log Out</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- 登录弹窗 -->
    <LoginModal
      v-if="isLoginModalVisible"
      @close="closeLoginModal"
      @showForgotPassword="showForgotPasswordModal"
    />

    <!-- 忘记密码弹窗 -->
    <ForgotPasswordModal
      v-if="isForgotPasswordModalVisible"
      @close="closeForgotPasswordModal"
      @backToLogin="backToLogin"
    />

    <!-- 注册弹窗 -->
    <SignupModal v-if="isSignupModalVisible" @close="closeSignupModal" />

    <!-- 收藏弹窗 -->
    <FavoriteModal
      v-if="isFavoriteModalVisible"
      @close="closeFavoriteModal"
      @showLogin="showLoginFromFavorite"
      @showSignup="showSignupFromFavorite"
    />

    <!-- 用户菜单 -->
    <UserMenu :visible="isUserMenuVisible" @close="closeUserMenu" />
  </div>
</template>

<script>
import LoginModal from './modals/LoginModal.vue'
import ForgotPasswordModal from './modals/ForgotPasswordModal.vue'
import SignupModal from './modals/SignupModal.vue'
import FavoriteModal from './modals/FavoriteModal.vue'
import UserMenu from './UserMenu.vue'
import userStore from '../store/user.js'

export default {
  name: 'Header',
  components: {
    LoginModal,
    ForgotPasswordModal,
    SignupModal,
    FavoriteModal,
    UserMenu
  },
  data() {
    return {
      isLoginModalVisible: false,
      isForgotPasswordModalVisible: false,
      isSignupModalVisible: false,
      isFavoriteModalVisible: false,
      isUserMenuVisible: false,
      isDropdownOpen: false,
      isMobileMenuOpen: false,
      scrollPosition: undefined,
      userStore: userStore.state
    }
  },
  computed: {
    isLoggedIn() {
      return this.userStore.isLoggedIn
    },
    userInitial() {
      if (this.userStore.user && this.userStore.user.name) {
        return this.userStore.user.name.substring(0, 2).toUpperCase()
      }
      return 'LS'
    },
    userName() {
      return this.userStore.user?.name || 'User'
    }
  },
  mounted() {
    // 监听全局事件,显示收藏弹窗
    this.$root.$on('show-favorite-modal', this.showFavoriteModal)
    // 检查登录状态
    userStore.checkAuth()
    // 监听点击事件,点击外部关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('show-favorite-modal', this.showFavoriteModal)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (this.isMobileMenuOpen) {
        this.lockScroll()
      } else {
        this.unlockScroll()
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.unlockScroll()
    },
    showLoginModal() {
      this.closeMobileMenu()
      this.isLoginModalVisible = true
      this.lockScroll()
    },
    closeLoginModal() {
      this.isLoginModalVisible = false
      this.unlockScroll()
    },
    showForgotPasswordModal() {
      this.isLoginModalVisible = false
      this.isForgotPasswordModalVisible = true
    },
    closeForgotPasswordModal() {
      this.isForgotPasswordModalVisible = false
      this.unlockScroll()
    },
    backToLogin() {
      this.isForgotPasswordModalVisible = false
      this.isLoginModalVisible = true
    },
    showSignupModal() {
      this.closeMobileMenu()
      this.isSignupModalVisible = true
      this.lockScroll()
    },
    closeSignupModal() {
      this.isSignupModalVisible = false
      this.unlockScroll()
    },
    showFavoriteModal() {
      // 如果已登录,直接收藏,否则显示弹窗
      if (this.isLoggedIn) {
        this.$toast('Added to favorites!')
        return
      }
      this.isFavoriteModalVisible = true
      this.lockScroll()
    },
    closeFavoriteModal() {
      this.isFavoriteModalVisible = false
      this.unlockScroll()
    },
    showLoginFromFavorite() {
      this.isFavoriteModalVisible = false
      this.isLoginModalVisible = true
    },
    showSignupFromFavorite() {
      this.isFavoriteModalVisible = false
      this.isSignupModalVisible = true
    },
    toggleUserMenu() {
      this.isUserMenuVisible = !this.isUserMenuVisible
    },
    closeUserMenu() {
      this.isUserMenuVisible = false
    },
    async handleLogout() {
      const confirmed = await this.$confirm('Are you sure you want to log out?')
      if (confirmed) {
        userStore.logout()
        this.isDropdownOpen = false
        // 只在不在首页时才跳转
        if (this.$route.path !== '/') {
          this.$router.push('/').catch(() => { })
        }
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    handleClickOutside(event) {
      // 检查点击是否在下拉菜单外部
      const dropdown = event.target.closest('.x-dropdown')
      if (!dropdown && this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    },
    isActive(path) {
      // 判断当前路由是否匹配
      return this.$route.path === path
    },
    lockScroll() {
      // 保存当前滚动位置
      // if (!document.body.classList.contains('modal-open')) {
      //   this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      //   document.body.classList.add('modal-open')
      //   document.body.style.top = `-${this.scrollPosition}px`
      //   document.body.style.position = 'fixed'
      //   document.body.style.width = '100%'
      // }
    },
    unlockScroll() {
      // 检查是否还有其他弹窗或菜单打开
      if (this.isLoginModalVisible || this.isSignupModalVisible ||
        this.isForgotPasswordModalVisible || this.isFavoriteModalVisible ||
        this.isMobileMenuOpen) {
        return
      }

      // 恢复滚动位置
      document.body.classList.remove('modal-open')
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''

      if (this.scrollPosition !== undefined) {
        window.scrollTo(0, this.scrollPosition)
        this.scrollPosition = undefined
      }
    }
  }
}
</script>

<style scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ff0000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.logged-in-nav .eLGvhP {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logged-in-nav .eXNqpM {
  display: flex;
  align-items: center;
}

.logged-in-nav .htRjuh {
  display: flex;
  align-items: center;
}

.fGDFIV {
  background-color: rgb(255, 255, 255);
  border: none;
  height: 100px;
  position: relative;
  z-index: 10;
}

.bFLUky {
  margin: 0px auto;
  padding: 30px 0px;
  width: 100%;
}

.bABEsA {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
}



.ioMmig {
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  flex: 1 1 0%;
  -webkit-box-pack: start;
  justify-content: flex-start;
}

.jwXipJ {
  margin-right: 50px;
}

.jzQpMF {
  display: flex;
}

.jRZLKX {
  margin-right: 50px;
}

.giQiXZ {
  color: rgb(0, 0, 0);
  font-size: 18px;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
}

.giQiXZ.active {
  color: rgb(255, 194, 0);
  font-weight: 600;
}

.bDWafU {
  border: 2.5px solid rgb(255, 194, 0);
  border-radius: 2.5px;
  bottom: -10px;
  position: absolute;
  width: 100%;
}

.fydLGD {
  fill: rgba(0, 0, 0, 0);
  stroke: rgb(0, 0, 0);
  stroke-width: 5px;
  transition: all 0.3s ease;
}

.fydLGD2 {
  fill: rgba(255, 194, 0, 1);
  stroke: rgb(255, 194, 0);
  stroke-width: 5px;
}
.iPsaAj {
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  flex: 1 1 0%;
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.eTftWW {
  position: relative;
}

.eTftWW img {
  color: rgb(0, 122, 232);
  cursor: pointer;
  width: 23px;
}

@media (max-width: 1366px) {
  .bFLUky {
    width: 94%;
  }
}

@media (min-width: 1367px) {
  .bFLUky {
    max-width: 1700px;
    width: 92%;
  }
}
</style>
